import React, { useState } from "react";
import { Spacer, Stack, Typography } from "digiwash-components";
import { TouchableOpacity } from "react-native";
import { formatNumber } from "digiwash-core";
import CustomIcon from "../CustomIcon";

interface VariationType {
  quantity?: number;
  onSelectPlus: (count?: number) => void;
  onSelectMinus: (count?: number) => void;
  cartMode?: boolean;
}

function Variation(props: VariationType) {
  let { quantity } = props;
  let [count, setCount] = useState(quantity);
  let sizeOfButton = props.cartMode ? 32 : 48;
  return (
    <Stack>
      <TouchableOpacity
        onPress={() => {
          let nextCount = count + 1;
          props.onSelectPlus(nextCount);
          setCount(nextCount);
        }}
        disabled={count === 0 && props.cartMode}
      >
        <Stack
          bg="primary.light970"
          style={{
            width: sizeOfButton,
            height: sizeOfButton,
            borderRadius: 50,
          }}
          distribution="center"
        >
          <CustomIcon icon="add" width={14} height={14} />
        </Stack>
      </TouchableOpacity>
      <Spacer size="m" />
      <Typography color="common.black">{formatNumber(count)}</Typography>
      <Spacer size="m" />
      <TouchableOpacity
        disabled={count === 0}
        onPress={() => {
          let previousCount = count - 1 > 0 ? count - 1 : 0;
          props.onSelectMinus(previousCount);
          setCount(previousCount);
        }}
      >
        <Stack
          bg={count === 0 ? "common.white" : "primary.light970"}
          style={{
            width: sizeOfButton,
            height: sizeOfButton,
            borderRadius: 50,
          }}
          distribution="center"
        >
          {count === 0 ? (
            <CustomIcon icon="minusDisabled" width={14} height={2} />
          ) : (
            <CustomIcon icon="minus" width={14} height={2} />
          )}
        </Stack>
      </TouchableOpacity>
    </Stack>
  );
}

export default Variation;
